import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  fromRefcode: '',

  accessToken: '',
  accessExpires: '',

  isAuthorized: false,

  loginStatus: '',
  loginClientId: '',
  signupStatus: '',
  forgotPwStatus: '',
  resetTokenStatus: '',
  resetPwStatus: '',
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setFromRefcode: (state, action) => {
      state.fromRefcode = action.payload;
    },

    setAccessToken: (state, action) => {
      state.accessToken = action.payload;
    },
    setAccessExpires: (state, action) => {
      state.accessExpires = action.payload;
    },

    setIsAuthorized: (state, action) => {
      state.isAuthorized = action.payload;
    },

    setLoginStatus: (state, action) => {
      state.loginStatus = action.payload;
    },
    setLoginClientId: (state, action) => {
      state.loginClientId = action.payload;
    },
    setSignupStatus: (state, action) => {
      state.signupStatus = action.payload;
    },
    setForgotPwStatus: (state, action) => {
      state.forgotPwStatus = action.payload;
    },
    setResetTokenStatus: (state, action) => {
      state.resetTokenStatus = action.payload;
    },
    setResetPwStatus: (state, action) => {
      state.resetPwStatus = action.payload;
    },

    resetAuth: () => initialState,
  },
});

export const {
  setFromRefcode,

  setAccessToken,
  setAccessExpires,

  setIsAuthorized,

  setLoginStatus,
  setLoginClientId,
  setSignupStatus,
  setForgotPwStatus,
  setResetTokenStatus,
  setResetPwStatus,

  resetAuth,
} = authSlice.actions;

export default authSlice.reducer;
